import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Howl } from 'howler';


@Component({
  selector: 'app-media-player',
  templateUrl: './media-player.component.html',
  styleUrls: ['./media-player.component.scss'],
})
export class MediaPlayerComponent implements OnInit, OnDestroy, OnChanges {

  @Input() src: string

  media: Howl
  playing: boolean = false
  interval = null
  sliderPosition: number = 0;
  currentTime: number = 0;
  totalTime: number = 0;

  constructor() { }

  ngOnInit() {
    this.startPlayer()
  }

  startPlayer() {
    if (this.src.includes('null')) return
    this.media = new Howl({
      // src: ['/assets/audio/mixkit-simple-countdown-922.wav'],
      src: [this.src],
      // format: ['mp3'],
      html5: true,
      onend: () => {
        this.playing = false;
      },
      onplay: () => {
        this.playing = true
        this.totalTime = this.media.duration() * 1000
      },
      onpause: () => {
        this.playing = false;
      }
    });

    this.interval = setInterval(() => {
      this.updateProgress()
    }, 1000);

    // this.media.play();
  }

  updateProgress() {
    if (this.media.playing()) {
      const position = (this.media.seek() / this.media.duration()) * 100;
      this.sliderPosition = Math.round(position)
      this.currentTime = this.media.seek() * 1000
    }
  }

  sliderChange(ev) {
    const time = this.media.duration() / 100 * ev.target.value
    this.media.seek(time)
  }

  play() {
    if (this.media.playing())
      this.media.pause()
    else
      this.media.play()

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.src.currentValue) {
      this.media = changes.src.currentValue
      this.startPlayer()
    }
  }

  ngOnDestroy() {
    this.media.stop()
    clearInterval(this.interval)
  }

}
